import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import { Grid } from '@material-ui/core'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydSelect from '../../../../commonDesign/SydSelect'
import Switch from '../../../../molecules/Switch'
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from './constants'

const pageSizeSelectOptions = PAGE_SIZE_OPTIONS.map(s => ({ value: s, label: String(s) }))

function UserLoginActivityConfigEditor ({ fieldPrefix }) {
  const { control } = useFormContext()
  const configPrefix = `${fieldPrefix}.config`

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <Controller
          name={`${configPrefix}.defaultPageSize`}
          control={control}
          render={({ field }) => (
            <SydLabel label='Default rows per page'>
              <SydSelect
                options={pageSizeSelectOptions}
                value={field.value || DEFAULT_PAGE_SIZE}
                onChange={(e) => field.onChange(Number(e.target.value))}
              />
            </SydLabel>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          name={`${configPrefix}.showUserAgent`}
          control={control}
          render={({ field }) => (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '3px 10px',
                fontSize: 'var(--font-size-sm)'
              }}
            >
              <span className='mr-3'>Show User Agent column</span>
              <Switch
                checked={field.value ?? true}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            </div>
          )}
        />
      </Grid>
    </Grid>
  )
}

UserLoginActivityConfigEditor.propTypes = {
  fieldPrefix: PropTypes.string.isRequired
}

export default UserLoginActivityConfigEditor
